import { isNil } from 'ramda';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FontSizeTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface ITextLinkAnchorProps {
	colorVariant?: 'light' | 'dark';
	variant?: 'normal' | 'bold';
	mobileSize?: FontSizeTypes;
	desktopSize?: FontSizeTypes;
}

export interface ITextLinkProps extends ITextLinkAnchorProps {
	label: string;
	href: string;
	newTab?: boolean;
}

const Anchor = styled.a<ITextLinkAnchorProps>`
	font-weight: ${({ theme: components, variant }) =>
		variant && components.textLink[variant].fontWeight};
	font-family: ${({ theme: components, variant }) =>
		variant && components.textLink[variant].fontFamily};
	color: ${({ theme: components, colorVariant = 'dark' }) =>
		components.textLink.color[colorVariant]};
	font-size: ${({ theme: components, mobileSize }) =>
		!isNil(mobileSize) ? theme.fontSizes.body[mobileSize] : components.textLink.mobileSize};
	line-height: ${theme.lineHeights.body.md};
	text-decoration: none;
	border-bottom: 1px solid
		${({ theme: components, colorVariant = 'dark' }) => components.textLink.color[colorVariant]};
	width: fit-content;

	@media ${theme.responsive.breakpoints.tablet} {
		font-size: ${({ theme: components, desktopSize }) =>
			!isNil(desktopSize) ? theme.fontSizes.body[desktopSize] : components.textLink.desktopSize};
	}

	:hover {
		border-bottom: 2px solid
			${({ theme: components, colorVariant = 'dark' }) => components.textLink.color[colorVariant]};
	}
`;

const TextLink: FC<ITextLinkProps> = ({ label, href, newTab, ...splatProps }) => {
	return (
		<Anchor href={href} target={newTab ? '_blank' : undefined} {...splatProps}>
			{label}
		</Anchor>
	);
};

export default styled(TextLink)``;
